module.exports = __webpack_public_path__ + "img/facebook.ab320b74.svg";